/**
 * Contenu éditorial — livraisons internationales (produits hors stock local).
 * Source unique pour la fiche produit détails.
 *
 * Aucun tarif n'est écrit ici : les montants viennent du barème backend
 * (`GET /pricing`) via `formatShippingRate`. Un tarif figé dans ce texte
 * mentirait dès que `amount_per_kg` ou `amount_per_cbm` change en base.
 */

export const INTERNATIONAL_SHIPPING_MODES = [
  {
    id: "avion",
    apiValue: "fret aérien",
    title: "Avion Express",
    tagline: "Le plus rapide",
    delay: "5 à 7 jours A/D (Après le Départ)",
    delayShort: "5–7 jours A/D",
    pricing: "Au poids de la commande",
    idealFor:
      "Les produits urgents, de grande valeur ou à forte rotation.",
    payment:
      "80 % des frais de transport sont à régler à la commande et 20 % à la réception.",
    note:
      "Si ton colis est très volumineux mais léger, le transport est calculé sur son volume (poids volumétrique) plutôt que sur son poids réel.",
  },
  {
    id: "bateau",
    apiValue: "fret maritime",
    title: "Fret Maritime",
    tagline: "Le plus économique",
    delay: "60 à 90 jours (selon les départs)",
    delayShort: "60–90 jours",
    pricing: "au CBM (m³)",
    pricingDetail:
      "1 CBM correspond à l'espace occupé par votre marchandise dans le conteneur.",
    payment:
      "Les frais de transport peuvent être réglés à l'arrivée de la marchandise.",
    // Le coût de l'exemple se calcule à l'affichage : volume × tarif du barème.
    example: {
      intro: "Un carton de 60 × 50 × 40 cm occupe 0,12 CBM.",
      volume: 0.12,
    },
  },
];

export const INTERNATIONAL_SHIPPING_WHY = {
  title: "Pourquoi ces prix et ces délais ?",
  intro:
    "Chez Chinexpress, les expéditions sont organisées en groupage, c'est-à-dire que les marchandises de plusieurs clients sont regroupées dans un même envoi. Ce fonctionnement permet de partager les frais de transport et de vous proposer des tarifs bien plus avantageux.",
  modes: [
    {
      title: "Avion Express",
      text: "Les départs sont fréquents, ce qui permet une livraison rapide. Une fois ta commande traitée et réceptionnée à notre entrepôt, le poids final est confirmé. Elle est ensuite expédiée et arrive à Libreville entre 5-7 jours, avant retrait ou la livraison à domicile.",
    },
    {
      title: "Bateau",
      text: "Le transport maritime offre le tarif le plus économique, car tu ne paies que l'espace occupé par tes marchandises dans le conteneur. Les expéditions sont lancées une fois le conteneur prêt au départ, ce qui explique un délai estimé de 2 à 3 mois.",
    },
  ],
};

export const INTERNATIONAL_SHIPPING_NOTES = [
  "Les frais de transport sont estimés à partir des données de poids et de volume fournies par nos fournisseurs, selon les unités commandées.",
  "Le montant final peut être légèrement ajusté après contrôle en entrepôt (poids/volume réel après emballage et regroupement).",
  "Les frais de transport incluent déjà les frais de douane. Aucun frais supplémentaire à l'arrivée.",
  "Les délais de livraison sont estimatifs et peuvent varier selon différents facteurs (météo, formalités administratives, période, etc.).",
];
